import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";

const getFileName = (url) => {
    try {
        return url.split("/").pop().split("?")[0] || "download";
    } catch {
        return "download";
    }
};

export const handleDownloadURL = async ({ fileUrl, setLoading }) => {
    if (!fileUrl) return;

    setLoading?.(true);
    const downloadName = getFileName(fileUrl);

    try {
        const response = await fetch(fileUrl);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = downloadName;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Download failed:", error);
        window.open(fileUrl, "_blank");
    } finally {
        setLoading?.(false);
    }
};

const DownloadFile = ({ fileUrl, className = "", label = "" }) => {
    const [loading, setLoading] = useState(false);

    const onDownload = (e) => {
        e.stopPropagation();
        if (loading) return;
        handleDownloadURL({ fileUrl, setLoading });
    };

    return (
        <button
            type="button"
            onClick={onDownload}
            disabled={loading}
            className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 transition disabled:opacity-50"
        >
            <ArrowDownTrayIcon className="h-4 w-4 text-gray-600 group-hover:text-blue-600" />
            {label && (
                <span className="text-xs font-medium text-gray-700">
                    {label}
                </span>
            )}
        </button>
    );
};

export default DownloadFile;
